module.exports = __webpack_public_path__ + "static/img/case_6.cf0ab582.jpg";